<template>
  <div
    class="banner-wrapper"
    @mouseenter="pauseAutoPlay"
    @mouseleave="startAutoPlay"
  >
    <!-- 轮播内容 -->
    <div class="banner" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <div v-for="(img, i) in images" :key="i" class="slide">
        <img :src="img" />
      </div>
    </div>

    <!-- 左按钮 -->
    <button class="banner-btn left-btn" @click="prevSlide">‹</button>

    <!-- 右按钮 -->
    <button class="banner-btn right-btn" @click="nextSlide">›</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require("@/assets/banner1.jpg"),
        require("@/assets/banner2.jpg"),
        require("@/assets/banner3.jpg"),
      ],
      currentIndex: 0,
      timer: null,
    };
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    pauseAutoPlay() {
      clearInterval(this.timer);
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
  },
};
</script>

<style scoped>
.banner-wrapper {
  position: relative; /* 为按钮定位 */
  width: 60%;
  margin: 0 auto;
  margin-top: 20px;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 轮播内容 */
.banner {
  display: flex;
  transition: transform 0.5s ease;
}

/* 每张图片 */
.slide {
  flex: 0 0 100%;
}

.slide img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

/* 左右按钮通用样式 */
.banner-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;

  background: rgba(0, 0, 0, 0.05);
  color: white;
  font-size: 24px;
  cursor: pointer;
  transition: 0.3s;
}

/* 按钮悬停效果 */
.banner-btn:hover {
  background: rgba(0, 0, 0, 0.55);
}

/* 左右位置 */
.left-btn {
  left: 15px;
}

.right-btn {
  right: 15px;
}

/* 小屏幕适配 */
@media screen and (max-width: 768px) {
  .banner-wrapper {
    width: 90%;
  }
  .slide img {
    height: 120px;
  }
  .banner-btn {
    width: 32px;
    height: 32px;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue